module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/modules/_library.js
// module id = 5cQY
// module chunks = 0